var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext, useWatch } from "react-hook-form";
import { Box, Stack } from "@mui/material";
import { ErrorMessage } from "../../../Atoms";
import { HookChip } from "../../";
var HookChipGroup = function (_a) {
    var options = _a.options, fieldName = _a.fieldName, disabled = _a.disabled, _b = _a.registerOptions, registerOptions = _b === void 0 ? {} : _b, _c = _a.listStyles, listStyles = _c === void 0 ? {} : _c, _d = _a.containerStyles, containerStyles = _d === void 0 ? { mr: 2, mb: 2 } : _d;
    var _e = useFormContext(), register = _e.register, errors = _e.formState.errors;
    // hook chips dont register the overal field, manually register here for required validation
    register(fieldName, registerOptions);
    var selectedValue = useWatch({ name: fieldName });
    return (_jsxs(_Fragment, { children: [_jsx(Stack, __assign({ sx: listStyles }, { children: options.map(function (option) { return (_jsx(Box, __assign({ sx: containerStyles }, { children: _jsx(HookChip, __assign({}, option, { disabled: disabled || option.disabled, selected: option.value === selectedValue, fieldName: fieldName })) }), option.value)); }) })), _jsx(ErrorMessage, { errors: errors, name: fieldName })] }));
};
export default HookChipGroup;
